import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import type { Site } from '@hotjar/site';
import { getState, getStateFromServer } from '@hotjar/webapp/domains/activation/tracking-code';
import type { TrackingCodeState } from '@hotjar/webapp/domains/activation/tracking-code/types';
import { useCurrentSite } from '@hotjar/site';

export interface TrackingCodeFunctions {
  getState: (lastData: Site['lastData'] | undefined) => TrackingCodeState;
}

export const useTrackingCode = (): TrackingCodeFunctions => {
  return { getState: (lastData) => getState(lastData || null) };
};

export const useTrackingCodeStateFromServer = (
  site: Site,
): UseQueryResult<TrackingCodeState, Error> => {
  return useQuery('tracking-code-state-from-server', () => getStateFromServer(site), {
    cacheTime: 0,
    retry: false,
  });
};

export const useTrackingCodeState = (): TrackingCodeState => {
  const { getState: getTrackingCodeState } = useTrackingCode();
  const currentSite = useCurrentSite().data;

  return getTrackingCodeState(currentSite?.lastData || null);
};
